

export const wanFAQ = {
    title: 'Wan 2.5 常見問題（原生音訊影片生成）',
    sub: '完整介紹 Wan 2.5 的音視覺生成能力、定價、內容政策，以及與其他 AI 影片模型的比較。',
    items: [
      { num: '01', q: '什麼是 Wan 2.5？原生音訊有何獨特之處？', a: 'Wan 2.5 是阿里巴巴的 AI 影片生成模型，具業界首創的原生音訊能力。不同於只生成無聲影片的工具，Wan 2.5 可在生成畫面的同時產生同步對白、背景音樂、音效與唇形對齊。' },
      { num: '02', q: 'Wan 2.5 與其他 AI 影片模型相比如何？', a: '優勢包括原生音訊生成、10 秒時長、友善的積分定價、較寬鬆的內容政策與強大的多語言支援。視覺品質具競爭力，並以獨特音訊能力脫穎而出。' },
      { num: '03', q: '影片時長、解析度與比例有哪些選項？', a: '時長：5 秒或 10 秒。解析度：720p 或 1080p。比例：16:9、9:16、1:1。文字轉影片支援所有比例；圖片轉影片沿用原圖比例。皆包含原生音訊。' },
      { num: '04', q: 'Wan 2.5 費用如何計算？', a: '採積分制按次計費。示例：5 秒 720p = 60 點、5 秒 1080p = 100 點；10 秒 720p = 120 點、10 秒 1080p = 200 點。價格皆含原生音訊。' },
      { num: '05', q: '能生成哪些內容？是否有內容限制？', a: '在遵循法規前提下，Wan 2.5 以較寬鬆的審核政策支援大膽、動態的創作。適合社群媒體、廣告行銷、藝術創作與商業用途。' },
      { num: '06', q: '影片可以商用嗎？版權如何？', a: '可以。所有生成的影片與音訊皆可商用，你擁有輸出內容的權利。原生音訊也減少背景音樂與音效的版權顧慮。' },
      { num: '07', q: '如何讓原生音訊效果更好？', a: '在提示詞中描述期望的音訊（如「史詩電影配樂」「森林環境聲」），並指定運鏡與畫面節奏。可使用反向提示排除不需要的音訊元素。' },
      { num: '08', q: '是否支援多種語言？', a: '是。具備優秀的多語言支援（含中文），可正確發音並與唇形對齊。' }
    ],
    cta: '還有關於 Wan 2.5 的問題？',
    contact: '聯絡支援團隊'
  };
